<template>
    <div>
      
        <b-collapse  :open="true" v-for="(component,index) in components" :key="index" :aria-id="component.componentName+''+index" >
            <a  class="word-b-all" slot="trigger" href="#" v-scroll-to="'#M'+component.key" :class="(asideMenu === component.key)?'has-text-primary':''" @click="$emit('setFormComponent',component)" :slot-scope="component.componentName+''+index" :title="component.componentName" >
                <span >
                     <b-icon  v-if="component.children.length !== 0" pack="fas" size="is-small" icon="plus-circle" class="has-text-grey-light is-size-7"></b-icon>
                        <span class="is-size-5 has-text-weight-semibold mg-1">{{component.componentName}}</span>
                    <b-icon v-if="getCompelete(component.key) === true" pack="fas" size="is-small" icon="check-circle" class="has-text-success is-size-7"></b-icon>
                </span> 
            </a>
                <ul v-if="component.children.length !== 0" :aria-controls="component.componentName+''+index">
                    <div v-for="(childrens,childrensIndex) in component.children" :key="childrensIndex">
                        <li  ><a class="word-b-all"  @click="$emit('setFormComponent',component)" href="#" v-scroll-to="'#M'+childrens.key"  :title="childrens.componentName">
                                <span class="is-size-6 has-text-weight-semibold mg-1">
                                    {{childrens.componentName}}
                                    <b-icon v-if="getCompelete(childrens.key) === true" pack="fas" size="is-small" icon="check-circle" class="has-text-success mg-1 is-size-7 "></b-icon>
                                </span>  
                            </a>
                        </li>
                        <FormAside v-if="childrens.children.length !== 0" :components="childrens.children" :getCompelete="getCompelete"/>
                    </div>
                </ul>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name:'FormAside',
        props:['components','setFormComponent','asideMenu','getCompelete'],
        data() {
            return {
            }
        },
        methods: {
            logData(data){
                console.log("dsfsdfdsfdsfdsfsdf",data)
            }
        },
    }
</script>
<style scoped>

</style>
